import React, {useContext, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {EditCourseContext} from "../../../context/EditCourseProvider";
import styled from "styled-components";
import {Grid, Col} from "../../../styles/Grid";
import {Input} from "../../../styles/Forms";
import EditableImg from "../../../components/forms/EditableImg";
import nextId from "react-id-generator";
import {ButtonWithIcon, AppButton} from "../../../styles/Butttons";
import {ReactComponent as PlusIcon} from "../../../assets/icons/plus.svg";
import {ReactComponent as CancelIcon} from "../../../assets/icons/cancel.svg";
import {CreateTestimonialService, UpdateTestimonialService} from "../../../services/CoursesServices";
import AppLoader, {LoadComponet} from "../../../components/loaders/Loader";
import {Label} from "../../../components/forms/DynamicInput";

let clean = {
   idTestimonial: nextId(),
   title: "",
   pathImage: "",
   pathVideo: "",
   longDescription: "",
};

export default function FormPartTestimonials({continueAction, theme, isActive}) {
   const {getTestimonialsByCourse, testimonialsCourse, deleteTest, updatingData} = useContext(EditCourseContext);
   const [testToSave, setTestToSave] = useState([]);
   const [isSaving, setSaving] = useState(false);
   const [editMode, setEditMode] = useState({isActive: false, data: {}});
   let {id} = useParams();

   useEffect(() => {
      if (isActive) {
         getTestimonialsByCourse();
      }
   }, [isActive]);

   // useEffect(() => {}, [testimonialsList]);

   // NUEVO
   const saveNew = (e) => {
      e.preventDefault();
      setSaving(true);

      let fileIMG = e.target.imgTest.files ? e.target.imgTest.files[0] : false;
      let filesVideo = e.target.videoTest.files ? e.target.videoTest.files[0] : false;

      if (!filesVideo || !fileIMG) return false;

      let toSaveData = new FormData();

      toSaveData.append("idCourse", id);
      toSaveData.append("title", e.target.title.value);
      toSaveData.append("longDescription", e.target.longDescription.value.replace(/\n/g, "<br>"));
      toSaveData.append("pathImage", fileIMG);
      toSaveData.append("pathVideo", filesVideo);
      toSaveData.append("token", localStorage.getItem("domecq_token"));
      e.persist();

      CreateTestimonialService(toSaveData)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            getTestimonialsByCourse(true);
         })
         .then(() => {
            e.target.reset();
         })
         .then(() => setSaving(false))
         .catch((e) => {
            setSaving(false);
            console.log(e);
         });
   };

   const openEdit = (test) => {
      setEditMode({isActive: true, data: test});
   };

   const updateTest = (e) => {
      e.preventDefault();
      setSaving(true);

      let toSaveData = new FormData();

      toSaveData.append("idCourse", id);
      toSaveData.append("idTestimonial", e.target.idTestimonial.value);
      toSaveData.append("title", e.target.title.value);
      toSaveData.append("longDescription", e.target.longDescription.value.replace(/\n/g, "<br>"));
      if (e.target.imgTest.files) {
         toSaveData.append("pathImage", e.target.imgTest.files[0]);
      }
      if (e.target.videoTest.files) {
         toSaveData.append("pathVideo", e.target.videoTest.files[0]);
      }
      toSaveData.append("token", localStorage.getItem("domecq_token"));
      e.persist();

      UpdateTestimonialService(toSaveData)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
            getTestimonialsByCourse(true);
         })
         .then(() => {
            e.target.reset();
         })
         .then(() => {
            setEditMode({isActive: false, data: {}});
         })
         .then(() => setSaving(false))
         .catch((e) => {
            setSaving(false);
            console.log(e);
         });
   };

   return (
      <>
         <AllGrid>
            <Col large={12}>
               <TitleSecion>Testimonios</TitleSecion>
            </Col>
            {!editMode.isActive && (
               <>
                  <Grid>
                     {testimonialsCourse.isLoading ? (
                        <LoadComponet />
                     ) : (
                        React.Children.toArray(
                           testimonialsCourse.data.map((test) => {
                              return (
                                 <ColTest large={6}>
                                    <Label>{test.title}</Label>
                                    <FlatButton
                                       color="#32529d"
                                       onClick={() => {
                                          openEdit(test);
                                       }}
                                    >
                                       Editar &#9998;
                                    </FlatButton>
                                    <FlatButton color="crimson" onClick={() => deleteTest(test.idTestimonial)}>
                                       Eliminar &#215;
                                    </FlatButton>
                                 </ColTest>
                              );
                           }),
                        )
                     )}
                  </Grid>
                  <ItemTes as="form" onSubmit={saveNew}>
                     <Col large={12}>
                        <Col large={12}>
                           <Grid>
                              <Col large={6}>
                                 <Input placeholder="Título" name="title" required />
                              </Col>
                           </Grid>
                        </Col>
                        <Grid>
                           <Col large={6} className="colItem">
                              <Grid>
                                 <Col large={12} className="fileInput">
                                    <EditableImg
                                       editable={true}
                                       name={`imgTest`} 
                                       label="Imagen (Medidas aprox 394px X 317px)"
                                       required={true}
                                    />
                                 </Col>
                                 <Col large={12} className="fileInput">
                                    <EditableImg editable={true} name={`videoTest`} type="video" label="Vídeo" required={true} />
                                 </Col>
                              </Grid>
                           </Col>
                           <Col large={6} className="colItem">
                              <TextArea as="textarea" placeholder="Descripción" name="longDescription" required></TextArea>
                           </Col>
                           <Col large={2} offsetL={10}>
                              <AppButton>Publicar</AppButton>
                           </Col>
                        </Grid>
                     </Col>
                  </ItemTes>
               </>
            )}

            {editMode.isActive && (
               <ItemTes as="form" onSubmit={updateTest}>
                  <Col large={12}>
                     <Col large={12}>
                        <Grid>
                           <Col large={6}>
                              <Input placeholder="Título" name="title" required defaultValue={editMode.data.title} />
                              <Input type="hidden" placeholder="Título" name="idTestimonial" defaultValue={editMode.data.idTestimonial} />
                           </Col>
                        </Grid>
                     </Col>
                     <Grid>
                        <Col large={6} className="colItem">
                           <Grid>
                              <Col large={12} className="fileInput">
                                 <EditableImg
                                    editable={true}
                                    name={`imgTest`}
                                    fileName={editMode.data.pathImage}
                                    label="Imagen"
                                    required={true}
                                 />
                              </Col>
                              <Col large={12} className="fileInput">
                                 <EditableImg
                                    editable={true}
                                    name={`videoTest`}
                                    fileName={editMode.data.pathVideo}
                                    type="video"
                                    label="Vídeo"
                                    required={true}
                                 />
                              </Col>
                           </Grid>
                        </Col>
                        <Col large={6} className="colItem">
                           <TextArea
                              as="textarea"
                              placeholder="Descripción"
                              name="longDescription"
                              defaultValue={editMode.data.longDescription.replace(/<br>/gi, "\n")}
                              required
                           ></TextArea>
                        </Col>
                        <Col large={6} offsetL={6}>
                           <Grid>
                              <Col large={5} offsetL={1}>
                                 <AppButton
                                    as="div"
                                    color="crimson"
                                    onClick={() => {
                                       setEditMode({isActive: false, data: {}});
                                    }}
                                 >
                                    Cancelar
                                 </AppButton>
                              </Col>
                              <Col large={5} offsetL={1}>
                                 <AppButton>Publicar</AppButton>
                              </Col>
                           </Grid>
                        </Col>
                     </Grid>
                  </Col>
               </ItemTes>
            )}
         </AllGrid>
         <AppLoader isVisible={isSaving || updatingData} />
      </>
   );
}
const AllGrid = styled(Grid)`
   .sepTop {
      margin-top: 2em;
   }
`;

const TitleSecion = styled.p`
   font-size: 1.5em;
   font-weight: 400;
   color: #1c355e;
   margin: 1em 0 1.5em 0;
`;

const ColTest = styled(Col)`
   display: flex;
   align-items: center;
`;

const FlatButton = styled.button`
   color: ${(props) => props.color};
   background: transparent;
   border: none;
   outline: none;
   font-size: 1em;
   padding: 0.5em 0.9em;
   cursor: pointer;

   &:hover {
      color: white;
      background: ${(props) => props.color};
   }
`;

const ItemTes = styled(Grid)`
   & .colItem {
      padding: 0.5em 0;
      box-sizing: border-box;

      &:first-child {
         padding-right: 0.5em;
      }
      &:last-child {
         padding-left: 0.5em;
      }
   }

   & .fileInput {
      margin-top: 1em;

      & .row {
         width: 90%;
      }
   }
`;

const TextArea = styled(Input)`
   resize: none;
   width: 100%;
   border: 1px solid grey;
   padding: 0.5em;
   height: 120px;
   font-family: Montserrat;
`;
